import { useSelector } from "react-redux";
import { RootState } from "../../store";

export const usePermission = (moduleId: any) => {
    const permissions = useSelector((state: RootState) => state?.auth?.permissions);    
    return permissions?.find((perm: any) => perm?.fk_SubModuleId === moduleId && perm?.view===true) || {};
};
